import to_casher from './casher'
import buyVIP from '../../api/order'
// import {video_schema} from './videoSchema'
import {openLink} from './link'
import download_app from '../../tools/mgtv/downapp'
import {pauseAllVideo} from './video'
import process_award from '../../components/ConfigUI/Lottery/process_award'
import scrollTop from '../../tools/scrollTop'
import {getAward} from '../../api/getAward'
import ClsIdCard from '../../tools/idcard'
import {getTryUseAward} from '../../api/tryUse'
import buyUnionVip from '../../api/unionVip'
import {isString, isFunction} from "../typeof";

import {LIST_SEPARATER} from '../../constant/separator'


export function rulerDialog(action_info, success_cb, cancel_cb) {
  const title = action_info.title;
  const rulers = action_info.rulers;
  const button = action_info.button;
  const rulerLines = rulers.split(/\n/).reduce((total, item, index, array) => {
    if (index === 1) {
      total = `<p style='font-size:.28rem;line-height:.32rem;margin-bottom: 0.1rem;text-align: justify;'>${total}</p>`
    }
    return total + `<p style='font-size:.28rem;line-height:.32rem;margin-bottom: 0.1rem;text-align: justify;'>${item}</p>`
  })
  return window.$act_alert_dialog.show({
    "title": `<div style='text-align: center;font-size: .34rem;padding-bottom:.4rem;'>${title}</div>
        <div style='max-height: 5rem;overflow-y:scroll;-webkit-overflow-scrolling: touch;'>${rulerLines}</div>`,
    "button": button
  }).then(() => {
    if (isFunction(success_cb)) {
      success_cb();
    }
  }).catch(e => {
    if (isFunction(cancel_cb)) {
      cancel_cb();
    }
  });
}

export default function (info, success_cb = null, cancel_cb = null) {
  const action_info = info.action_info;
  let source = window.gact.source;
  switch (info.action_type) {
    //跳链
    case 'link':
      setTimeout(() => {
        openLink(action_info.url);
      }, 100);
      break;
    //收银台
    case "cashier":
      pauseAllVideo();
      to_casher();
      break;
    //分享弹窗
    case 'shareDialog':
      window.$share_dialog.show(action_info);
      break;
    //直接开通会员
    case 'openVip':
      // if (action_info.need_new_user) {
      //   if (window.$bus.user.user_type !== 1) {
      //     window.$toast('仅限新用户购买哦~');
      //     return;
      //   }
      // }
      const product_id = action_info.product_id;
      console.log('购买产品', product_id);
      if (!action_info.openVipLimit) {
        buyVIP(product_id);
        break;
      }

      switch (action_info.openVipLimit) {
        case 'student':
          window.$submit_dialog.show({
            submitDialog: {
              title: "24周岁及以下用户专属,请先认证",
              submit: "提交",
              fields: [
                {
                  label: '姓名',
                  type: 'name',
                  placeholder: '请输入姓名',
                  min: 2,
                  max: 10
                },
                {
                  label: '身份证',
                  type: 'idcard',
                  placeholder: '请输入身份证号',
                }
              ]
            },
            submitAction: (submit_info) => {
              return new Promise((resolve, reject) => {
                const idcard = submit_info[1].value;
                const age = new ClsIdCard(idcard).GetAge();
                console.log('age', age);
                if (age > 24) {
                  window.$toast('认证失败，仅24周岁及以下用户专属，请核实您的身份信息');
                } else {
                  buyVIP(product_id);
                }
                resolve('success');
              })
            },
            recv_info: null
          }).then(res => {

          }).catch(res => {
          })

          break;
        default:
          buyVIP(product_id);
          break;
      }


      break;
    //下载APP
    case 'downloadApp':
      setTimeout(() => {
        download_app();
      }, 100);
      break;
    //纵向滚动
    case "scrollY":
      const scrollY = action_info.scroll / 100 * window.g_html_font_size;
      console.log('scrollY', scrollY)
      scrollTop.qScroll(scrollY);
      break;
    //规则弹窗
    case 'showRulerDialog':
      // const title = action_info.title;
      // const rulers = action_info.rulers;
      // const button = action_info.button;
      // const rulerLines = rulers.split(/\n/).reduce((total, item, index, array) => {
      //   if (index === 1) {
      //     total = `<p style='font-size:.28rem;line-height:.32rem;margin-bottom: 0.1rem;text-align: justify;'>${total}</p>`
      //   }
      //   return total + `<p style='font-size:.28rem;line-height:.32rem;margin-bottom: 0.1rem;text-align: justify;'>${item}</p>`
      // })
      // window.$act_alert_dialog.show({
      //   "title": `<div style='text-align: center;font-size: .34rem;padding-bottom:.4rem;'>${title}</div>
      //   <div style='max-height: 5rem;overflow-y:scroll;-webkit-overflow-scrolling: touch;'>${rulerLines}</div>`,
      //   "button": button
      // }).then(() => {
      // }).catch(e => {
      // });
      rulerDialog(action_info, success_cb, cancel_cb);
      break;
    //资产
    case 'toAssets':
      const assetType = action_info.assetType;
      let url = '';
      switch (assetType) {
        case 'index':
          url = '//club.mgtv.com/act/assets_index/index.html';
          break;
        case 'redpack':
          url = '//club.mgtv.com/act/vip_assets/index.html#/redpack';
          break;
        case 'giftcard':
          url = '//club.mgtv.com/act/vip_assets/index.html#/giftcard';
          break;
        case 'awards':
          url = '//club.mgtv.com/act/vip_assets/index.html#/awards';
          break;
        case 'dianbo':
          url = '//club.mgtv.com/act/vip_assets/index.html#/dianbo';
          break;
        default:
          break;
      }
      if (url) {
        window.location.href = (url + '?source=' + source);
      }
      break;
    case 'toGiftCard': //礼品卡
      window.location.href = ('//club.mgtv.com/activity/2018/giftcard_cust/index.html' + '?source=' + source);
      break;
    case 'getAward'://领取奖品
      getAward('lego' + info.id);
      break;
    case 'tryUse': //商务试用，站外用，签约送会员
      if (window.gact.is_ios_app) {
        buyVIP(action_info.try_product_id); //IOS端直接购买苹果试用产品
      } else {
        getTryUseAward(action_info.try_product_id, action_info.try_days);
      }
      break;
    case 'toast':
      window.$toast(action_info.toast);
      break;
    case 'unionVIP':
      const reg_name = new RegExp("\\$\\{NAME\\}", 'g');
      const reg_vip = new RegExp("\\$\\{VIP\\}", 'g');

      const name = action_info.union_name;
      const vip = action_info.union_vip_name.replace(reg_name, name);
      action_info.union_vip_name = vip;

      for (let k in action_info) {
        if (k === 'union_name' || k === 'union_vip_name') {
          continue;
        }
        if (isString(action_info[k])) {
          action_info[k] = action_info[k].replace(reg_name, name);
          action_info[k] = action_info[k].replace(reg_vip, vip);
        }
      }
      buyUnionVip(action_info);
      break;

    // case 'imgDialog':
    //   window.$img_dialog.show({...info.imgDialog});
    //   break;
    // case 'htmlDialog':
    //   window.$html_dialog.show({htmlDialog: info.htmlDialog});
    //   break;
    // case 'submitDialog':
    //   window.$submit_dialog.show({submitDialog: info.submitDialog}).then(() => {
    //     console.log('submitDialog success')
    //   }).catch(err => {
    //     console.log('submitDialog cancel')
    //   });
    //   break;
    // case 'actAlertDialog':
    //   window.$act_alert_dialog.show({...info.actAlertDialog}).then(() => {
    //   }).catch(e => {
    //   })
    //   break;
    // case 'fakeLotteryDialog':
    //   console.log(info)
    //   process_award(info.fakeLotteryDialog.award_info);
    //   break;
    case 'lotteryHistoryDialog':
      window.$lottery_history_dialog.show().then(res => {
      }).catch(e => {
      });
      break;
    case 'goBack':
      window.history.go(-1);
      break;
    case 'hideShow':
      const show_ids = action_info.show_ids.split(LIST_SEPARATER)
      const hide_ids = action_info.hide_ids.split(LIST_SEPARATER);
      console.log(hide_ids,show_ids);
      window.$bus.tpl.comps.forEach(item => {
        if (show_ids.indexOf(item.id + '') >= 0) {
          item.hide = false
        }
        if (hide_ids.indexOf(item.id + '')  >= 0) {
          item.hide = true
        }
      });


      break;

    default:
      break;
  }
}



// WEBPACK FOOTER //
// ./src/tools/mgtv/action.js